import React from 'react';
import PropTypes from 'prop-types';
import './Chat.css';

import ActionUser from './ActionUser';

function Message({ color = `#989898`, username, userID = null, usercolor, content, separator = ``, type, active = false, avatar = null }) {
  return (
    <div className={`chat-message type-medium fz13`} style={{ color }}>
      <ActionUser userID={userID} label={`${username}${separator}`} color={usercolor} />
      {content}
    </div>
  )
}

Message.propTypes = {
  userID: PropTypes.any,
  color: PropTypes.string.isRequired,
  username: PropTypes.string.isRequired,
  usercolor: PropTypes.string,
  content: PropTypes.string.isRequired,
  separator: PropTypes.string,
  type: PropTypes.string,
  active: PropTypes.bool,
  avatar: PropTypes.string,
}

export default Message;
